import { render, staticRenderFns } from "./TabItemModal.vue?vue&type=template&id=5896ccde"
import script from "./TabItemModal.vue?vue&type=script&lang=js"
export * from "./TabItemModal.vue?vue&type=script&lang=js"
import style0 from "./TabItemModal.vue?vue&type=style&index=0&id=5896ccde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports